import { useLocation } from 'react-router-dom';
import { getAllDetails } from '../../service/ApiService';
import { PENDING_TAX_FORM_LIST } from '../../config/ApiConstant';
import CommonTaxFileList from './CommonTaxFileList';

const TaxpayerStatus = () => {
    const location = useLocation();
    const passedState = location.state as { status?: string, start_date?: string, end_date?: string, filter_by?: string } | null;

    const fetchData = async (searchStr?: string) => {
        let status = 'Pending';
        if (passedState?.status) {
            status = passedState.status;
        }

        let endpoint = `${PENDING_TAX_FORM_LIST}?type=${encodeURIComponent(status)}`;

        if (passedState?.start_date && passedState?.end_date) {
            endpoint += `&start_date=${passedState.start_date}&end_date=${passedState.end_date}`;
        } else {
            endpoint += `&filter_by=All`;
        }

        if (searchStr) {
            endpoint += `&search=${searchStr}`;
        }

        const response = await getAllDetails(endpoint);
        const data = Array.isArray(response) ? response : (response?.pending_list || response?.data || []);
        return data;
    };

    return (
        <CommonTaxFileList
            fetchData={fetchData}
            pageTitle={`${passedState?.status} List` || "Taxpayer Status List"}
            breadcrumbMenu="Taxpayer Status"
            storagePrefix="pendingList"
            emptyMessage="No data found."
            refreshDependencies={[passedState]}
        />
    );
};

export default TaxpayerStatus;